import { render, staticRenderFns } from "./BtnNew.vue?vue&type=template&id=e1be4e38&"
import script from "./BtnNew.vue?vue&type=script&lang=js&"
export * from "./BtnNew.vue?vue&type=script&lang=js&"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports